module.exports = __webpack_public_path__ + "img/size.bdca0b49.svg";